import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo, { breadcrumbSchema } from "@/components/Seo";
import { Reveal, Stagger, StaggerItem } from "@/components/Reveal";
import { Overline } from "@/components/Btn";
import { Breadcrumb } from "@/components/Breadcrumb";
import { CtaBand } from "@/components/CtaBand";
import { SECTEURS } from "@/data/secteurs";

export default function Secteurs() {
  const crumbs = [
    { label: "Accueil", to: "/" },
    { label: "Secteurs", to: "/secteurs/" },
  ];
  return (
    <>
      <Seo
        title="Enseignes par secteur d'activité | Ronalp Enseigne"
        description="Enseignes lumineuses adaptées à chaque métier : restaurants, pharmacies, hôtels, commerces, garages et concessions automobiles. Fabrication & pose, France & Suisse."
        path="/secteurs/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <section className="relative overflow-hidden border-b border-white/10">
        <div className="absolute inset-0 -z-10 bg-grid bg-grid-fade opacity-30" />
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 lg:py-16">
          <Breadcrumb items={crumbs} />
          <Reveal className="mt-8 max-w-3xl">
            <Overline>Secteurs d'activité</Overline>
            <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase tracking-tight text-white leading-[0.98]">Des enseignes pour chaque métier</h1>
            <p className="mt-5 text-lg text-slate-300">Chaque activité a ses contraintes et ses opportunités de visibilité. Découvrez nos solutions d'enseignes et de signalétique adaptées à votre secteur.</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SECTEURS.map((s) => (
            <StaggerItem key={s.slug}>
              <Link to={`/${s.slug}/`} className="group block h-full overflow-hidden rounded-xl border border-white/10 bg-ink-800 hover:border-signature/40 transition-all" data-testid={`secteur-page-${s.slug}`}>
                <div className="relative h-44 overflow-hidden">
                  <img src={s.image} alt={s.h1} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink-800 via-ink-800/30 to-transparent" />
                </div>
                <div className="p-6">
                  <h2 className="text-lg font-semibold text-white group-hover:text-signature transition-colors">{s.label}</h2>
                  <p className="mt-2 text-sm text-slate-400 line-clamp-2">{s.intro[0]}</p>
                  <span className="mt-4 inline-flex items-center gap-1 text-xs font-mono uppercase tracking-wider text-chrome-mid group-hover:text-signature transition-colors">Découvrir <ArrowUpRight className="h-3.5 w-3.5" /></span>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </Stagger>
      </section>

      <CtaBand />
    </>
  );
}
